import type { ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { MobileNav } from './MobileNav';

interface DesktopShellProps {
  children: ReactNode;
}

export function DesktopShell({ children }: DesktopShellProps) {
  return (
    <div
      style={{
        minHeight: '100vh',
        background: 'var(--bg-page)',
        color: '#0f1e3d',
        fontFamily: 'Geist, sans-serif',
        fontSize: 14,
        display: 'flex',
      }}
    >
      <Sidebar />
      <div
        className="app-shell-content"
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          minWidth: 0,
        }}
      >
        {children}
      </div>
      <MobileNav />
    </div>
  );
}
